import type { SupWeb3Address } from "@/types";
import { useEffect, useMemo, useState } from "react";

import { getAddress } from "viem";
import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";
import { useEstimateGas } from "wagmi";

export default function useViemEstimateTx(data: string | undefined, to: SupWeb3Address | undefined, value: bigint | undefined) {
  const userAddress = useWeb3UserAddress();

  const [gasPrice, setGasPrice] = useState<bigint | undefined>(undefined);

  const rawArgumentsForPrepareSendTx = useMemo(
    () => ({
      data: data as SupWeb3Address,
      to: to ? getAddress(to) : undefined,
      value: value,
      account: userAddress as SupWeb3Address,
    }),
    [to, data, value, userAddress]
  );

  const { data: gasData, error: prepareError, isLoading: isPrepareLoading } = useEstimateGas(rawArgumentsForPrepareSendTx);

  useEffect(() => {
    if (data) {
      if (prepareError || isPrepareLoading || !gasData) {
        setGasPrice(undefined);
      } else {
        setGasPrice(gasData);
      }
    }
  }, [rawArgumentsForPrepareSendTx, data, gasData, prepareError, isPrepareLoading]);

  return gasPrice;
}
